import { Point } from "highcharts";
import moment from "moment";
import { CommitmentDateGranularDataPoint } from "@/services/cloudchipr.api";
import { money } from "@/utils/numeral/money";

interface GenerateUtilizationAndCoverageMultiTypeChartTooltipArgs {
  point: Point;
  dataGroupedByDate?: Record<string, CommitmentDateGranularDataPoint>;
  labelFormatter: (value: string) => string;
}
export const generateUtilizationAndCoverageMultiTypeChartTooltip = ({
  point,
  dataGroupedByDate,
  labelFormatter,
}: GenerateUtilizationAndCoverageMultiTypeChartTooltipArgs) => {
  if (!point?.key) {
    return "";
  }
  const category = moment(point.key)?.format("DD MMM YYYY") ?? "";

  const coveragePercent = dataGroupedByDate?.[point.key].coverage.percent;
  const coverageAmount = dataGroupedByDate?.[point.key].coverage.amount;
  const utilizationPercent = dataGroupedByDate?.[point.key].utilization.percent;
  const utilizationAmount = dataGroupedByDate?.[point.key].utilization.amount;
  return `
           <div style="padding: 4px; font-family: sans-serif; font-size: 12px;">
  <div style="margin-bottom: 8px; font-weight: 500; font-size: 14px; color:#757575">
    ${category && labelFormatter?.(category?.toString())}
  </div>

  <div style="display: flex; align-items: center; margin-top: 4px;">
    <span style="display: inline-block; width: 4px; height: 16px; background-color: #9575CD; border-radius: 2px; margin-right: 8px;"></span>
    <span style=" color: #757575; margin-right: 4px" >Utilization </span>
    <span style="font-weight: bold;">${utilizationPercent}% (${money(utilizationAmount)})</span>
  </div>

  <div style="display: flex; align-items: center; margin-top: 4px;">
    <span style="display: inline-block; width: 4px; height: 16px; background-color: #42A5F5; border-radius: 2px; margin-right: 8px;"></span>
    <span style="color: #757575; margin-right: 4px">Coverage</span>
    <span style="font-weight: bold;">${coveragePercent}% (${money(coverageAmount)})</span>
  </div>
</div>
           `;
};
